import { render, staticRenderFns } from "./IlpaDiscography.vue?vue&type=template&id=6f95b9b8&scoped=true"
import script from "./IlpaDiscography.vue?vue&type=script&lang=js"
export * from "./IlpaDiscography.vue?vue&type=script&lang=js"
import style0 from "./IlpaDiscography.vue?vue&type=style&index=0&id=6f95b9b8&prod&lang=scss&scoped=true"
import style1 from "./IlpaDiscography.vue?vue&type=style&index=1&id=6f95b9b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95b9b8",
  null
  
)

export default component.exports